import {
  CUSTOMER_CARD_ADDED,
  CUSTOMER_CARD_ADDED_SUCCESS,
  CUSTOMER_CARD_ADDED_ERROR,
  GET_CUSTOMER_CARDS,
  GET_CUSTOMER_CARDS_SUCCESS,
  GET_CUSTOMER_CARDS_ERROR,
} from "./actionType";

export const customerCardAdded = (response) => ({
  type: CUSTOMER_CARD_ADDED,
  payload: response,
});

export const customerCardAddedSuccess = (response) => ({
  type: CUSTOMER_CARD_ADDED_SUCCESS,
  payload: response,
});

export const customerCardAddedError = (response) => ({
  type: CUSTOMER_CARD_ADDED_ERROR,
  payload: response,
});

// Get Customer Cards List
export const getCustomerCards = () => ({
  type: GET_CUSTOMER_CARDS,
});

export const getCustomerCardsSuccess = (response) => ({
  type: GET_CUSTOMER_CARDS_SUCCESS,
  payload: response,
});

export const getCustomerCardsError = (response) => ({
  type: GET_CUSTOMER_CARDS_ERROR,
  payload: response,
});
